export const LONG_DELAY = Number(process.env.REACT_APP_LONG_DELAY);
